import { Component, HostListener } from '@angular/core';
import { Meta } from '@angular/platform-browser';

/**
 * App-Root component
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  private contentMinWidth = 640; // $ContentMinWidth in px

  constructor(public meta: Meta) {
    this.updateMetaViewport();
  }

  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange() {
    this.updateMetaViewport();
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  /**
   * Update Viewport MetaTag
   * Update InitialScale Value to load Page correctly on small screens
   */
  async updateMetaViewport() {
    await this.delay(500);
    if (window.outerWidth && window.outerWidth < this.contentMinWidth) {
      /*const scaleRatio = window.outerWidth / this.contentMinWidth;
      this.meta.updateTag({
        name: 'viewport', 
        content: 'width=device-width, initial-scale=' + scaleRatio 
        + ', minimum-scale=' + scaleRatio + ', maximum-scale=' + scaleRatio
        + ', user-scalable=no'
      });*/

      this.meta.updateTag({
        name: 'viewport',
        content: 'width=' + this.contentMinWidth,
      });
    } else if (window.outerWidth && window.outerWidth > this.contentMinWidth) {
      this.meta.updateTag({name: 'viewport', content: 'width=device-width, initial-scale=1'});
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/app.component.ts